/**
 * OrbDocTutorialsIntermediateCrossOrbitalSLOrbDocTutorialsIntermediateCrossOrbitalSLPage
 *
 * Page component for OrbDocTutorialsIntermediateCrossOrbitalSLOrbDocTutorialsIntermediateCrossOrbitalSLPage
 * Path: /sl/docs/tutorials/intermediate/cross-orbital
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsIntermediateCrossOrbitalSLDocScreenView as __OrbDocTutorialsIntermediateCrossOrbitalSLDocScreenView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalSLDocScreenView';
import { OrbDocTutorialsIntermediateCrossOrbitalSLDocAnalyticsView as __OrbDocTutorialsIntermediateCrossOrbitalSLDocAnalyticsView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsIntermediateCrossOrbitalSLOrbDocTutorialsIntermediateCrossOrbitalSLPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsIntermediateCrossOrbitalSLOrbDocTutorialsIntermediateCrossOrbitalSLPage(_props: OrbDocTutorialsIntermediateCrossOrbitalSLOrbDocTutorialsIntermediateCrossOrbitalSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Dogodki med orbitali","description":"Poveži dva orbitala z zunanjim dogodkom in kvalificiranim poslušanjem, ne da bi kateri segel v drugega.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/intermediate/cross-orbital"},{"locale":"ar","path":"/ar/docs/tutorials/intermediate/cross-orbital"},{"locale":"sl","path":"/sl/docs/tutorials/intermediate/cross-orbital"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsIntermediateCrossOrbitalSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsIntermediateCrossOrbitalSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsIntermediateCrossOrbitalSLOrbDocTutorialsIntermediateCrossOrbitalSLPage;
